const doc = [({"da":({"js":({"components":({"newsletter_template_time_zone_states":({"send_button":({"send":"Send", "sending_has_been_queued":"Afsending er blevet sat i kø."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;